import DomElement from 'utils/DomElement';

export default class App {
    constructor() {
        this.elements = {};
        this.onReadyElements = [];
        this.onResizeElements = [];
    }

    static getLanguage() {
        return window.jQuery('html').attr('lang');
    }

    addElement(key, object) {
        this.elements[key] = object;
    }

    registerOnReadyElement(key) {
        this.onReadyElements.push(key);
    }

    registerOnResizeElement(key) {
        this.onResizeElements.push(key);
    }

    onReady() {
        let self = this;

        window.outdatedBrowser({
            bgColor: '#f25648',
            color: '#ffffff',
            lowerThan: 'transform',
            languagePath: '/static/dist/libs/outdatedbrowser/' + App.getLanguage() + '.html'
        });
        
        for(let key of this.onReadyElements) {
            this.elements[key].onReady();
        }

        window.jQuery(window).resize(() => {
            self.onResize();
        });
    }

    onResize() {
        for(let key of this.onResizeElements) {
            this.elements[key].onResize();
        }
    }
}


// WEBPACK FOOTER //
// ./app/global/App.js